import { css, type Theme } from "@emotion/react";

export const secureText = css`
  max-width: 12.5rem;
  margin-bottom: 0.5rem;
`;

export const hipaaGreyIcon = (theme: Theme) => css`
  flex-shrink: 0;
  color: ${theme.ds5.asset.shade.white};
`;

export const hipaaTextStack = css`
  line-height: 1;
`;

export const inverseHipaaBadge = (theme: Theme) => css`
  border: ${theme.ds5.borderWeight.xsmall} solid ${theme.ds5.inverse.icon};
  border-radius: ${theme.ds5.radius.background.medium};
  padding: ${theme.ds5.spacing.gap.xsmall};
`;
